import React from 'react'
import styled from 'styled-components'

const LinesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  align-self: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 353px;
    align-self: center;
`}
`

const Line = styled.span<{ isCompleted: boolean }>`
  display: block;
  width: 35.5px;
  height: 3px;
  background-color: ${(props) => (props.isCompleted ? '#4AD3FF' : '#CDF3FF80')};
  transition: background-color 0.3s ease;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 12px;  
  `}
`

interface ProgressLinesProps {
  visibleSlides: number
  totalSlides: number
}

export default function ProgressLines({ visibleSlides, totalSlides }: ProgressLinesProps) {
  return (
    <LinesContainer>
      {Array.from({ length: totalSlides }).map((_, idx) => (
        <Line key={idx} isCompleted={idx < visibleSlides}></Line>
      ))}
    </LinesContainer>
  )
}
